export default __webpack_public_path__ + "static/media/6-10_icon.fdf57385.svg";